import * as ng from 'angular';
import { StPagination } from './st-pagination.directive';

export const StPaginationModule: string =
    ng.module('st-pagination', [
    ])
        .directive('stPagination', StPagination)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-pagination/st-pagination.module.ts